export enum SampleDataGeneratingStatus {
  Started = 'started',
  Finished = 'finished',
  Failed = 'failed',
}
